import { extendTheme, type ThemeConfig } from '@chakra-ui/react';

const config: ThemeConfig = {
  initialColorMode: 'dark',
  useSystemColorMode: false, // Disable system color mode to allow manual toggle
};

const theme = extendTheme({
  config,
  colors: {
    gray: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
    },
  },
  styles: {
    global: () => ({
      // Completely disabled - let CSS variables handle everything
      // Add toast container fixes
      '#chakra-toast-portal': {
        pointerEvents: 'none !important',
      },
      '.chakra-toast-manager-bottom, .chakra-toast-manager-bottom-right, .chakra-toast-manager-bottom-left': {
        pointerEvents: 'none !important',
        width: 'auto !important',
      },
      '.chakra-toast': {
        pointerEvents: 'auto !important',
        width: 'auto !important',
        maxWidth: '560px !important',
      },
    }),
  },
  components: {
    Button: {
      baseStyle: (props: any) => ({
        _hover: {
          opacity: 0.9,
        },
      }),
    },
    Menu: {
      baseStyle: (props: any) => ({
        list: {
          bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
          borderColor: props.colorMode === 'dark' ? 'gray.700' : 'gray.200',
        },
        item: {
          bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
          _hover: {
            bg: props.colorMode === 'dark' ? 'gray.700' : 'gray.100',
          },
        },
      }),
    },
    Alert: {
      baseStyle: {
        container: {
          width: 'auto',
          maxWidth: '560px',
        },
      },
    },
  },
});

export default theme;